import React, { useState } from "react";
import InputAutoComplet from "../input/InputAutoComplet";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import WRONG from "../../assets/wrong.svg";
import SAVE from "../../assets/submit.svg";
import CANCEL from "../../assets/cancel.svg";
import {getErrroRow, row_style, sr_style} from './ReconslationTableView'
import NumberInput from '../input/NumberInput'
import TextInput from '../input/TextInput'
import { buttonObject } from "./ReconslationTableView";
import { toast } from "react-toastify";
import {
    TableCell,
    TableRow,
} from "@mui/material";
import { errorToast } from "../../toast";
import { ReactSession } from "react-client-session";

export const ReconslationTableEdit = ({
    row,
    data,
    setData,
    setEditState,
    index,
    editRowBakup,
    setDisabledState
}) => {
    const [batchDataArray, setBatchDataArray] = useState([])
    const axiosPrivate = useAxiosPrivate()

    const APICall = (e, val, idx) => {
        if(val=== null || val===undefined){
            return
        }
        setBatchDataArray([])
        setData((current) =>
            current.map((value_x, index) =>
            index === idx
                ? {
                    ...value_x,
                    batch_number: val,
                }
                : value_x
            )
        );
            try {
            axiosPrivate
                .get(`/data_entry/batch_number/?search=${val}&box_id=${ReactSession.get(
                    "box_id"
                  )}`)
                .then((res) => {
                    setBatchDataArray(res.data);
                });
            } catch (e) {
                console.log(e);
            }
    };
    const displayDetailsHandler = (event, value, idx) => {
        if (value===null) {
            return
        }
        setData((current) =>
            current.map((value_x, index) =>
            index === idx
                ? {
                    ...value_x,
                    batch_number: value['batch_number'],
                    description: value['description'],
                }
                : value_x
            )
        );
    }

    const quantityHandler = (value, idx) => {
        setData((current) =>
            current.map((value_x, index) =>
            index === idx
                ? {
                    ...value_x,
                    quantity: value,
                }
                : value_x
            )
        );
    }
    const saveHandler = (row) => {
        toast.dismiss();
        const regex = new RegExp(/^\d+(\.\d{1,2})?$/);
        if (["", null, undefined].includes(row.batch_number)) {
            errorToast("Please enter batch number fields!", 1000);
            return;
        }
        if (row.quantity === "") {
            errorToast("Please enter quantity fields!", 1000);
            return;
        } 
        if (row.quantity === 0 || !regex.test(row.quantity)) {
            errorToast("Quantity should not be less than 1", 1000);
            return;
        }
        setEditState(null)
        setDisabledState(false)
    }
    const cancelEdit = (idx) => {
        if ((!editRowBakup?.batch_number && !editRowBakup?.description) || Object.entries(editRowBakup).length === 0) {
            setData((prevData) => {
                const newData = prevData.filter((item, itemIdx) => idx !== itemIdx);
                newData.forEach((item, idx) => {
                    item.sr_no = idx + 1;
                });
                return newData;
            });
        } else {
            setData((current) =>
                current.map((value_x, index) =>
                    index === idx
                        ? {
                            ...value_x,
                            batch_number: editRowBakup?.batch_number,
                            description: editRowBakup?.description,
                            quantity: editRowBakup?.quantity,
                        }
                        : value_x
                )
            );
        }
        setDisabledState(false)
        setEditState(null);
    };

  return (
    <TableRow key={row.sr_no} style={getErrroRow(row)}>
        <TableCell style={sr_style}>{
        <span className="reconcilation__verification__qty_error">
            {row.quantity === 0 && <img src={WRONG} alt="WRONG_QTY_ERROR" />}
            {row.sr_no}
        </span>
        }</TableCell>
        <TableCell style={row_style}>
        <TextInput
            value={row?.description}
            isDisable={true}
        />
        </TableCell>
        <TableCell style={row_style}>
        <InputAutoComplet
            setValue={setData}
            inputValue={data}
            InputList={batchDataArray}
            APICall={APICall}
            displayDetailsHandler={displayDetailsHandler}
            placeholder='Batch Number'
            idx={index}
            diaplayDropdown={['batch_number', 'description', 'date_of_expiry']}
            keyname={'batch_number'}
        />
        </TableCell>
        <TableCell style={row_style}>
        <NumberInput
            value={row?.quantity}
            idx={index}
            handler={quantityHandler}
            width={'100%'}
        />      
        </TableCell>
        <TableCell style={buttonObject}>
        <button
            className="reconcilation__verification__table_action"
            onClick={() => saveHandler(row)}
        >
            <img src={SAVE} alt="SAVE" />
        </button>
        <button
            className="reconcilation__verification__table_action"
            onClick={() => cancelEdit(index)}
        >
            <img src={CANCEL} width="9px" alt="CANCEL"
            />
        </button>
        </TableCell>
    </TableRow>
  )
}
